module.exports = __webpack_public_path__ + "img/logo.6f99debb.svg";